import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/MaintenancePage.css';
import '../styles/CommonText.css';
import maintenanceImage from '../assets/maintenance.svg';

const MaintenancePage = () => {
  return (
    <div className="maintenance-page">
      <div className="maintenance-container">
        
        <div className="maintenance-card-box highlight-box-orange">
          <header className="maintenance-header">
            <h1 className='titolo-manutenzione'>Stiamo Lavorando per Te!</h1>
            <p className='descrizione-hero-mini'>
              Ci scusiamo per l'inconveniente, ma questa sezione è attualmente in manutenzione.
            </p>
          </header>

          <div className="maintenance-content-row">
            <div className="maintenance-text-box">
              <p className='testo-info'>
                Stiamo aggiornando i nostri sistemi per offrirti un'esperienza migliore e servizi sempre più competitivi.
              </p>
              <p className='testo-info'><strong>Ritorna a trovarci presto!</strong></p>
              
              {/* Pulsante di ritorno coerente con la Home */}
              <div className="maintenance-actions" style={{marginTop: '20px'}}>
                <Link to="/" className="btn-custom-orange">Torna alla Home</Link>
              </div>
            </div>
            
            <div className="image-wrapper">            
               <img src={maintenanceImage} alt="Manutenzione" className="maintenance-img" />
            </div>   
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default MaintenancePage;